import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import isEmpty from "lodash/isEmpty";

export default function applicationMetricReducer(
  state = initialState.applicationMetrics,
  action
) {
  switch (action.type) {
    case types.GET_SCORED_FILES_SUM_SUCCESS:
      return {
        ...state.applicationMetrics,
        scoredCalculatedCount: isEmpty(action.metric)
          ? 0
          : action.metric[0]["datapoints"][0],
        scoredCalculatedChart: state.scoredCalculatedChart,
        fsdsTotalCalls: state.fsdsTotalCalls,
        fsdsChargeableCalls: state.fsdsChargeableCalls,
        fsdsTotalCallsByMonth: state.fsdsTotalCallsByMonth,
        fsdsChargeableCallsByMonth: state.fsdsChargeableCallsByMonth,
      };
    case types.GET_TOTAL_SCORED_BY_MONTH_SUCCESS:
      return {
        ...state.applicationMetrics,
        scoredCalculatedChart: action.metric,
        scoredCalculatedCount: state.scoredCalculatedCount,
        fsdsTotalCalls: state.fsdsTotalCalls,
        fsdsChargeableCalls: state.fsdsChargeableCalls,
        fsdsTotalCallsByMonth: state.fsdsTotalCallsByMonth,
        fsdsChargeableCallsByMonth: state.fsdsChargeableCallsByMonth,
      };
    case types.GET_FSDS_TOTAL_CALLS_SUCCESS:
      return {
        ...state.applicationMetrics,
        fsdsTotalCalls: isEmpty(action.metric)
          ? 0
          : action.metric[0]["datapoints"][0],
        fsdsChargeableCalls: state.fsdsChargeableCalls,
        fsdsTotalCallsByMonth: state.fsdsTotalCallsByMonth,
        fsdsChargeableCallsByMonth: state.fsdsChargeableCallsByMonth,
        scoredCalculatedChart: state.scoredCalculatedChart,
        scoredCalculatedCount: state.scoredCalculatedCount,
      };
    case types.GET_FSDS_CHARGEABLE_CALLS_SUCCESS:
      return {
        ...state.applicationMetrics,
        fsdsChargeableCalls: isEmpty(action.metric)
          ? 0
          : action.metric[0]["datapoints"][0],
        fsdsTotalCalls: state.fsdsTotalCalls,
        fsdsTotalCallsByMonth: state.fsdsTotalCallsByMonth,
        fsdsChargeableCallsByMonth: state.fsdsChargeableCallsByMonth,
        scoredCalculatedCount: state.scoredCalculatedCount,
        scoredCalculatedChart: state.scoredCalculatedChart,
      };
    case types.GET_FSDS_TOTAL_CALLS_BY_MONTH_SUCCESS:
      return {
        ...state.applicationMetrics,
        fsdsTotalCallsByMonth: action.metric,
        fsdsChargeableCalls: state.fsdsChargeableCalls,
        fsdsTotalCalls: state.fsdsTotalCalls,
        fsdsChargeableCallsByMonth: state.fsdsChargeableCallsByMonth,
        scoredCalculatedCount: state.scoredCalculatedCount,
        scoredCalculatedChart: state.scoredCalculatedChart,
      };
    case types.GET_FSDS_CHARGEABLE_CALLS_BY_MONTH_SUCCESS:
      return {
        ...state.applicationMetrics,
        fsdsChargeableCallsByMonth: action.metric,
        fsdsTotalCallsByMonth: state.fsdsTotalCallsByMonth,
        fsdsChargeableCalls: state.fsdsChargeableCalls,
        fsdsTotalCalls: state.fsdsTotalCalls,
        scoredCalculatedCount: state.scoredCalculatedCount,
        scoredCalculatedChart: state.scoredCalculatedChart,
      };
    default:
      return state;
  }
}
